import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|产品中心'
  }
  render() {
    return (
      <div style={{ background: '#f6f6f6' }}>
        <Header />
        <div className="productContent">
          <div className="productContent-title">
            <div className="productContent-title-h1">产品中心</div>
            <div className="productContent-title-text">PRODUCT CENTER</div>
          </div>
        </div>
        <div className="product">
          <Link to="/product/hardware.html">
            <div className="product-item" style={{ marginRight: '.8rem ' }}>
              <img className="product-item-img" src={require('../image/硬件banner.png')} />
              <div className="product-item-content">
                <div className="product-item-content-title">硬件产品</div>
                <div className="product-item-content-button">
                  了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem ' }} />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/product/solution.html">
            <div className="product-item">
              <img className="product-item-img" src={require('../image/软件banner.png')} />
              <div className="product-item-content">
                <div className="product-item-content-title">解决方案</div>
                <div className="product-item-content-button">
                  了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem ' }} />
                </div>
              </div>
            </div>
          </Link>
        </div>
        <Footer />
      </div>
    )
  }
}

export default index
